// EPL CUSTOM: opens Amp's back-in-stock form from the notify-me link (snippets/notify-me-epl.liquid).
//
// We build Amp's popover ourselves instead of using Amp's #BIS_trigger or generic
// BIS_trigger handlers:
// - Amp's default popover decides "sold out" from total stock across all locations, so a
//   variant sold out online but in stock in a store got no form.
// - Amp's createPopover merges every product into the shared BIS.Config.product, so after a
//   colour swap an earlier product's popover would submit the later product's id.
//   Each popover here gets its own product object.
//
// One delegated listener on document, so it survives the colour picker swapping the link
// (changeVariantAjax in main-product.liquid replaces the HTML without a page load).
(function () {
  if (window.notifyMeEplBound) return;
  window.notifyMeEplBound = true;

  var popoversByHandle = {};

  function readProduct(link) {
    var wrapper = link.closest('[data-notify-me-epl]');
    var script = wrapper && wrapper.querySelector('script[data-notify-me-epl-product]');
    if (!script) return null;

    var product;
    try {
      product = JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
    if (!product || !product.handle || !Array.isArray(product.variants)) return null;

    // Mark every variant sold out for Amp's browser check. Our own online-warehouse
    // check in pickup-availability.js already decides whether the link is shown.
    product.variants.forEach(function (variant) {
      variant.inventory_quantity = 0;
    });
    return product;
  }

  function getPopover(product) {
    if (!popoversByHandle[product.handle]) {
      var overrides = BIS.extend({}, window._BISConfig || {});
      delete overrides.product;
      var settings = BIS.extend({}, BIS.Config, overrides);
      // Assigned, not merged: BIS.extend would merge into the shared BIS.Config.product.
      settings.product = product;
      settings.productHandle = product.handle;
      settings.button = { visible: false };
      popoversByHandle[product.handle] = new BIS.Popover(settings);
    }
    return popoversByHandle[product.handle];
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-notify-me-epl-link]');
    if (!link) return;
    event.preventDefault();

    if (!window.BIS || !BIS.Popover || !BIS.Config) return;
    var product = readProduct(link);
    if (!product) return;

    var form = document.getElementById(link.dataset.productFormId);
    var input = form && form.querySelector('input[name="id"]');
    var variantId = (input && input.value) || link.dataset.fallbackVariantId;

    var popover = getPopover(product);
    popover.ready.then(function () {
      // Same short defer Amp's own trigger handler uses before showing the form.
      BIS.defer(13, function () {
        popover.form.show({ variantId: variantId });
      });
    });
  });
})();
